Masonry = require "masonry-layout"

class MasonryImages
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'masonry-images--bound'
            @.$grid = @.$el.querySelector '.masonry-images__grid'

            @.$el.classList.add 'masonry-images--bound'
            @.BindMasonry()
        return

    BindMasonry: ->
        @.masonry = new Masonry( @.$grid, {
            columnWidth: '.masonry-images__grid-sizer',
            gutter: '.masonry-images__grid-gutter',
            itemSelector: '.masonry-images__image',
            percentPosition: true,
            stamp: '.masonry-images__spacer'
        })
        return

BindMasonryImages = ->
    document.querySelectorAll '.masonry-images:not(.masonry-images--bound)'
        .forEach (el) ->
            new MasonryImages el
            return
    return

window.addEventListener 'bind-components', BindMasonryImages